import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Trash2, Minus, Plus, ShoppingCart, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';

export default function CartPage() {
  const { items, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-24 text-center" data-testid="empty-cart">
        <ShoppingCart className="w-14 h-14 text-stone-300 mx-auto mb-4" />
        <h1 className="text-2xl font-black text-stone-800 mb-2">Tu carrito está vacío</h1>
        <p className="text-stone-500 mb-6">Descubre nuestros packs y bonos de clases.</p>
        <Link to="/tienda" className="btn-natur inline-block px-8 py-3 rounded font-bold text-sm" data-testid="go-to-tienda">Ir a la tienda</Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-black text-stone-800 mb-8" data-testid="cart-title">Tu carrito</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-4">
          {items.map((item) => (
            <div key={item.productId} className="bg-white border border-stone-200 rounded-lg p-4 flex items-center gap-4" data-testid={`cart-item-${item.slug}`}>
              <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded" />
              <div className="flex-1">
                <Link to={`/producto/${item.slug}`} className="font-bold text-stone-800 hover:text-amber-600 transition-colors">{item.name}</Link>
                <p className="text-sm text-stone-500">{item.price.toFixed(2).replace('.', ',')} € / ud.</p>
              </div>
              <div className="flex items-center border border-stone-300 rounded">
                <button onClick={() => updateQty(item.productId, item.qty - 1)} className="p-2 hover:bg-stone-100 transition-colors" data-testid={`cart-minus-${item.slug}`}><Minus className="w-3.5 h-3.5" /></button>
                <span className="w-8 text-center text-sm font-bold">{item.qty}</span>
                <button onClick={() => updateQty(item.productId, item.qty + 1)} className="p-2 hover:bg-stone-100 transition-colors" data-testid={`cart-plus-${item.slug}`}><Plus className="w-3.5 h-3.5" /></button>
              </div>
              <span className="font-black text-stone-800 w-24 text-right">{(item.price * item.qty).toFixed(2).replace('.', ',')} €</span>
              <button onClick={() => removeItem(item.productId)} className="text-stone-400 hover:text-red-500 transition-colors p-1" data-testid={`cart-remove-${item.slug}`}>
                <Trash2 className="w-4.5 h-4.5" />
              </button>
            </div>
          ))}
        </div>

        <div className="bg-white border border-stone-200 rounded-lg p-6 h-max" data-testid="cart-summary">
          <h2 className="font-black text-stone-800 text-lg mb-4">Resumen del pedido</h2>
          <div className="flex justify-between text-sm text-stone-600 mb-2">
            <span>Subtotal</span><span>{total.toFixed(2).replace('.', ',')} €</span>
          </div>
          <div className="flex justify-between text-sm text-stone-600 mb-4">
            <span>Activación</span><span className="text-teal-600 font-bold">Inmediata</span>
          </div>
          <div className="border-t border-stone-200 pt-4 flex justify-between font-black text-stone-800 text-lg mb-6">
            <span>Total</span><span data-testid="cart-total">{total.toFixed(2).replace('.', ',')} €</span>
          </div>
          <button onClick={() => navigate('/checkout')} className="btn-natur w-full flex items-center justify-center gap-2 py-3 rounded font-bold text-sm" data-testid="go-to-checkout">
            Finalizar compra <ArrowRight className="w-4 h-4" />
          </button>
          <Link to="/tienda" className="block text-center text-sm text-stone-500 hover:text-stone-800 transition-colors mt-4">Seguir comprando</Link>
        </div>
      </div>
    </div>
  );
}
